'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'holly-berry';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7aa';
var svgPathData = 'M256 16a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm64 48a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM15.3 348.7L80 327.1c.9-48.8 1.3-74.8 1.4-78 2.9 .4 29.1 4.3 78.6 11.7 48.9-22.5 75.6-34.8 80-36.8-.9 4.8-6.2 33.7-16 86.6 19.4 46.3 29.6 70.7 30.7 73.3-2.2 .7-28.4 9-78.7 25-1.7 50.2-2.6 76.7-2.7 79.7-3.3-.7-28.5-5.9-75.5-15.7-50.1 24-77.4 37-81.8 39.1 1-4.8 6.9-34.4 17.8-88.9-21.1-43.3-32.3-66.4-33.8-69.3l15.3-5.1zM96 327.4l-.2 11.3-10.7 3.6-62.7 20.9 25.8 52.9 2.4 4.9-1.1 5.3-11.5 57.5 52.9-25.3 4.9-2.3 5.3 1.1 56.9 11.8 2.1-60.7 .4-11.3 10.8-3.4 62-19.7-23.9-57.2-1.8-4.4 .9-4.7 10.4-56.3-52 23.9-4.3 2-4.7-.7-60.6-9-1.1 59.8zm400.7 21.3l15.3 5.1c-1.4 3-12.7 26.1-33.8 69.3 10.9 54.5 16.8 84.1 17.8 88.9-4.4-2.1-31.7-15.1-81.8-39.1-47 9.8-72.2 15-75.5 15.7-.1-2.9-1-29.5-2.7-79.7-50.3-15.9-76.5-24.3-78.7-25 1.1-2.6 11.3-27 30.7-73.3-9.8-52.9-15.1-81.8-16-86.6 4.4 2 31.1 14.3 80 36.8 49.5-7.4 75.8-11.3 78.6-11.7 .1 3.1 .5 29.1 1.4 78l64.7 21.6zM416 327.4l-1.1-59.8-60.6 9-4.7 .7-4.3-2-52-23.9 10.4 56.3 .9 4.7-1.8 4.4-23.9 57.2 62 19.7 10.8 3.4 .4 11.3 2.1 60.7 56.9-11.8 5.3-1.1 4.9 2.3 52.9 25.3-11.5-57.5-1.1-5.3 2.4-4.9 25.8-52.9-62.7-20.9-10.7-3.6-.2-11.3zM112 144c0-33.2 25.2-60.4 57.5-63.7 1 5.4 2.5 10.7 4.5 15.7-25.6 1-46 22.1-46 48 0 26.5 21.5 48 48 48 25.8 0 46.9-20.4 48-46 5 2 10.3 3.5 15.7 4.5-3.3 32.3-30.5 57.5-63.7 57.5-35.3 0-64-28.7-64-64zm224 64c-33.2 0-60.4-25.2-63.7-57.5 5.4-1 10.7-2.5 15.7-4.5 1 25.6 22.1 46 48 46 26.5 0 48-21.5 48-48 0-25.8-20.4-46.9-46-48 2-5 3.5-10.3 4.5-15.7 32.3 3.3 57.5 30.5 57.5 63.7 0 35.3-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHollyBerry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;